import { Component, CUSTOM_ELEMENTS_SCHEMA, signal } from '@angular/core';
import { TranslatePipe } from '@skylab-angular-shared/pipes';
import { ButtonComponent, DialogContentComponentBase, DialogContentComponentIns, DialogHeaderComponentIns } from '@skylab-angular-shared/ui';
import { SkylabConfig } from '@skylab-shared/business';

@Component({
	selector: 'skl-session-expired-dialog',
	template: `
		<skl-dialog-content-ins>
			<skl-dialog-header-ins
				[title]="'technical-pages.no-admin-info.title' | translate"
				(onClose)="onCancel()">
			</skl-dialog-header-ins>
			<ins-content>
				<div class="align--small">
					<div>{{'technical-pages.no-admin-info.message-line-1' | translate}}</div>
					<div class="align--medium-top align--medium-bottom">{{'technical-pages.no-admin-info.message-line-2' | translate}}</div>
					<div>
						{{'technical-pages.no-admin-info.message-line-3' | translate}}
						<a [href]="contactFormUrl()" target="_blank"><span class="link">{{'technical-pages.no-admin-info.link' | translate}}</span>.</a>
					</div>
				</div>
			</ins-content>

			<ins-footer class="dialog__buttons">
				<skl-button
					(click)="onCancel()">
					{{'technical-pages.no-admin-info.buttons.confirm' | translate}}
				</skl-button>
			</ins-footer>
		</skl-dialog-content-ins>
	`,
	imports: [TranslatePipe, DialogContentComponentIns, DialogHeaderComponentIns, ButtonComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class NoAdminsInfoDialogComponent extends DialogContentComponentBase<any> {
	contactFormUrl = signal(SkylabConfig.contactForm);
}
